<h1 mat-dialog-title *ngIf="title">{{ title }}</h1>
<ng-container *ngIf="renderAsHtml; else plainText">
	<div [innerHTML]="message"></div>
</ng-container>

<ng-template #plainText>
	<p>{{ message }}</p>
</ng-template>

<div mat-dialog-actions>
	<button type="button" mat-button (click)="extraButtonFn" color="accent" *ngIf="extraButton">{{ extraButton }}</button>
	<span class="spacer"></span>
	<button id="id_cancel_btn" type="button" mat-button (click)="dialogRef.close(false)" *ngIf="hasCancel">{{ cancelButton }}</button>
	<button id="id_ok_btn" type="button" mat-button (click)="dialogRef.close(true)" cdkFocusInitial [color]="color" >{{ button }}</button>
</div>